import { render, staticRenderFns } from "./RefreshButton.vue?vue&type=template&id=6f5951e0&"
import script from "./RefreshButton.vue?vue&type=script&lang=js&"
export * from "./RefreshButton.vue?vue&type=script&lang=js&"
import style0 from "./RefreshButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2451456063/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f5951e0')) {
      api.createRecord('6f5951e0', component.options)
    } else {
      api.reload('6f5951e0', component.options)
    }
    module.hot.accept("./RefreshButton.vue?vue&type=template&id=6f5951e0&", function () {
      api.rerender('6f5951e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/RefreshButton.vue"
export default component.exports